import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Social from "./pages/Social";
import Hours from "./pages/Hours";
import GoogleReviews from "./pages/GoogleReviews";
import AdminPage from "./pages/admin"; // 👈 IMPORTANT

const MainPage: React.FC = () => {
  const homeRef = useRef<HTMLDivElement>(null);
  const aboutRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const socialRef = useRef<HTMLDivElement>(null);
  const hoursRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleScrollAndClose = (ref: React.RefObject<HTMLDivElement>) => {
    scrollToSection(ref);
    handleMenuClose();
  };

  const MEASUREMENT_ID = "G-YDM8W8K451";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        (window as any).dataLayer.push(args);
      }

      (window as any).gtag = gtag;

      gtag("js", new Date());
      gtag("config", MEASUREMENT_ID);
    };
  }, []);

  return (
    <Box sx={{ userSelect: "none" }} display="flex" flexDirection="column" bgcolor="#f5f5f5">
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#242435",
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ minHeight: 40, px: 0 }}>
            {isMobile ? (
              <>
                <IconButton
                  size="large"
                  edge="end"
                  color="inherit"
                  onClick={handleMenuOpen}
                  sx={{ ml: "auto" }}
                >
                  <MenuIcon sx={{ color: "#e0e0e0" }} />
                </IconButton>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                  <MenuItem onClick={() => handleScrollAndClose(homeRef)}>Home</MenuItem>
                  <MenuItem onClick={() => handleScrollAndClose(socialRef)}>Updates</MenuItem>
                  <MenuItem onClick={() => handleScrollAndClose(hoursRef)}>Hours & Events</MenuItem>
                  <MenuItem onClick={() => handleScrollAndClose(aboutRef)}>About</MenuItem>
                  <MenuItem onClick={() => handleScrollAndClose(contactRef)}>Contact</MenuItem>
                </Menu>
              </>
            ) : (
              <Box
                sx={{
                  position: "absolute",
                  right: "2%",
                  height: 48,
                  display: "flex",
                }}
              >
                <Button size="small" sx={{ color: "#e0e0e0" }} onClick={() => scrollToSection(homeRef)}>Home</Button>
                <Button size="small" sx={{ color: "#e0e0e0" }} onClick={() => scrollToSection(socialRef)}>Updates</Button>
                <Button size="small" sx={{ color: "#e0e0e0" }} onClick={() => scrollToSection(hoursRef)}>Hours & Events</Button>
                <Button size="small" sx={{ color: "#e0e0e0" }} onClick={() => scrollToSection(aboutRef)}>About</Button>
                <Button size="small" sx={{ color: "#e0e0e0" }} onClick={() => scrollToSection(contactRef)}>Contact</Button>
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <Box component="main" flex="1" mt={6}>
        <div ref={homeRef}><Home /></div>
        <div ref={socialRef}><Social /></div>
        <div ref={hoursRef}><Hours /></div>
        <div ref={aboutRef}><About /><GoogleReviews /></div>
        <div ref={contactRef}><Contact /></div>
      </Box>

      <Box component="footer" sx={{ backgroundColor: "#242435" }} py={3}>
        <Container maxWidth="lg">
          <Typography sx={{ color: "#e0e0e0" }} align="center">
            &copy; {new Date().getFullYear()} Primetime Gaming
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;